module.exports = __webpack_public_path__ + "media/images/athletes/3564-a30d70b3886ca573c44c6e38b4308051.png";